import styled from 'styled-components';

import { Input } from '../../../../../../../../components';
import { ThemeProp } from '../../../../../../../../theme/Themes';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  padding: 1rem 1.5rem 1.5rem 1.5rem;
  margin-bottom: 0;

  @media (max-width: ${(props: ThemeProp) => props.theme.breakpoints.mobile}) {
    padding-top: 0;
    border-bottom: 1px solid ${(props: ThemeProp) => props.theme.colors.neutrals.c100};
  }
`;

export const EmailInput = styled(Input).attrs((props) => ({
  ...props,
  css: {
    ...props.css,
    marginBottom: '0 !important',
  },
}))``;
